function get(url, data, cb, fail_cb) {
    var that = this;
    api.get(url, {params: data})
        .then((data) => {
            //this.$toast.clear()
            console.log('data', data);

            if (data.success) {
                if (data.msg) {
                    that.$message({message: data.msg, type: 'success'})
                }
                if (data.apiCode == 9007) {
                    //授权公众号不存在
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return
                }
                if (data.apiCode == 9006) {
                    //授权公众号未通过审核
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return;
                }
                if (cb) {
                    cb(data)
                }
            } else {
                if (data.apiCode === 8002) {
                    window.location.href = "/login.html"
                    return
                }
                if (data.msg) {
                    that.$message.error(data.msg)
                }
                if (fail_cb) {
                    fail_cb(data)
                }
            }

        })
        .catch(function (error) {
                //this.$toast.clear()
                if (error.response) {
                    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                    console.log(error)
                }
                console.log(error.config);
                if (fail_cb) {
                    fail_cb(error)
                }
            }
        );
}

function jsonpRequest(url, data, cb, fail_cb) {
    this.$jsonp(url, data).then(res => {
        console.log(res)
        if (cb) {
            cb(res)
        }
    }).catch(err => {
        console.log(err)
        if (fail_cb) {
            fail_cb(err)
        }
    })
}

function deleteRequest(url, data, cb, fail_cb) {
    var that = this;
    api.delete(url, {params: data}, cb, fail_cb)
        .then((data) => {
            //this.$toast.clear()
            console.log('data', data);

            if (data.success) {
                if (data.msg) {
                    that.$message({message: data.msg, type: 'success'})
                }
                if (data.apiCode == 9007) {
                    //授权公众号不存在
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return
                }
                if (data.apiCode == 9006) {
                    //授权公众号未通过审核
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return;
                }
                if (cb) {
                    cb(data)
                }
            } else {
                if (data.apiCode === 8002) {
                    window.location.href = "/login.html"
                    return
                }
                if (data.msg) {
                    that.$message.error(data.msg)
                }
                if (fail_cb) {
                    fail_cb(data)
                }
            }

        })
        .catch(function (error) {
            //this.$toast.clear()
            if (error.response) {
                // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

            } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
                console.log(error)
            }
            console.log(error.config);
            if (fail_cb) {
                fail_cb(error)
            }
        });
}

function post(url, data, headers, cb, fail_cb) {
    var that = this
    if (that.isSaving) {
        return
    }
    that.isSaving = true;
    api.post(url, data, {headers: headers})
        .then((data) => {
            that.isSaving = false;
            if (data.success) {
                if (data.msg) {
                    that.$message({message: data.msg, type: 'success'})
                }
                if (data.apiCode == 9007) {
                    //授权公众号不存在
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return
                }
                if (data.apiCode == 9006) {
                    //授权公众号未通过审核
                    window.location.href = "/mp_auth.html?code=" + data.apiCode
                    return;
                }
                if (cb) {
                    cb(data)
                }
            } else {
                if (data.apiCode === 8002) {
                    window.location.href = "/login.html"
                    return
                }
                if (data.msg) {
                    that.$message.error(data.msg)
                }
                if (fail_cb) {
                    fail_cb(data)
                }

            }
        })
        .catch(function (error) {
                that.isSaving = false;
                that.$message.error(error)
                if (error.response) {
                    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                }
                console.log(error.config);
                if (fail_cb) {
                    fail_cb(error)
                }
            }
        );
}


function commonRequest(url, data, cb, fail_cb) {
    get(url, data,
        function (res) {
            if (res.success) {
                if (cb) {
                    cb(res)
                }
            } else {
                if (fail_cb) {
                    fail_cb(res)
                }
            }


        },
        function (res) {
            if (fail_cb) {
                if (!res)
                    res = {msg: "请求出错"};
                if (!res.msg) {
                    res.msg = "请求出错";
                }
                fail_cb(res)
            }
        }
    )
}

var request = {
    get: get,
    post: post,
    jsonpRequest: jsonpRequest,
    commonRequest: commonRequest,
    deleteRequest: deleteRequest
}
export {request};
